import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const PurchaseRefund = lazyWithPreload(() => import('./PurchaseRefund'))
